/**
 * Phase 18.E — shared JWT-claim-parser.
 *
 * Backend signiert access-tokens mit folgenden claims (siehe
 * api/internal/auth/jwt/manager.go → Claims):
 *
 *   sub             — user-id (uuid)
 *   org_id          — tenant-id (uuid)
 *   role            — admin | leitung | betreuer | traeger_admin
 *   parent_org_id   — Phase 15 / ADR-008, optional, set für traeger_admin
 *   email           — optional anzeige-name
 *   exp             — JWT-standard expiry (unix sec) — access-token-lifetime
 *   lic_exp         — Phase 18, optional, lizenz-expiry (unix sec, 0 = no enforcement)
 *
 * Wir parsen den payload ohne signature-validation (das ist server-side-job;
 * client braucht die claims nur für UI-routing + license-banner). Bei einem
 * malformed token returnen wir {} statt zu werfen — die UI behandelt
 * empty-claims als "betreuer + no license" defaults.
 */
export interface JWTPayload {
  sub?: string;
  org_id?: string;
  role?: string;
  parent_org_id?: string;
  email?: string;
  exp?: number;
  /** Unix-seconds, omitempty (= no enforcement) */
  lic_exp?: number;
}

export function parseJWTClaims(token: string): JWTPayload {
  try {
    const segments = token.split(".");
    if (segments.length < 2) return {};
    const payloadSegment = segments[1];
    if (!payloadSegment) return {};
    const payload = JSON.parse(
      atob(payloadSegment.replace(/-/g, "+").replace(/_/g, "/")),
    );
    return payload as JWTPayload;
  } catch {
    return {};
  }
}
